import {useTranslation} from '@wix/yoshi-flow-editor'
import React, {useEffect, useState} from 'react'
import {isHeadless} from '../../../../../commons/selectors/environment'
import {useAppActions, useAppSelector} from '../../hooks/runtime'
import {
  canRetryFormSubmit,
  getFormSubmitError,
  getLastFormErrorTime,
  secondsTillFormSubmitIsAllowed,
} from '../../selectors/form-submit-errors'
import {isCheckoutActionPending, isRsvpActionPending} from '../../selectors/pending-requests'
import {Error} from '../form/commons/error'
import s from '../form/form.scss'
import {FormButton} from '../form-button/form-button'
import {FormSubmitButtonProps} from './interfaces'

export const FormSubmitButton = ({previewTooltipText, dataHook, text, disabled, onClick}: FormSubmitButtonProps) => {
  const {t} = useTranslation()
  const {openHeadlessErrorModal} = useAppActions()
  const [submitDelayed, setSubmitDelayed] = useState(false)

  const checkoutActionPending = useAppSelector(isCheckoutActionPending)
  const rsvpActionPending = useAppSelector(isRsvpActionPending)
  const headless = useAppSelector(isHeadless)
  const errorTime = useAppSelector(getLastFormErrorTime)
  const canRetrySubmit = useAppSelector(canRetryFormSubmit)
  const error = useAppSelector(state => getFormSubmitError(state, t))

  const timeout = secondsTillFormSubmitIsAllowed(errorTime)
  const showError = !submitDelayed && !(timeout && canRetrySubmit)

  useEffect(() => {
    if (headless && error && !canRetrySubmit) {
      openHeadlessErrorModal(error)
    }
  }, [headless, error, canRetrySubmit])

  useEffect(() => {
    if (errorTime && canRetrySubmit) {
      setSubmitDelayed(true)
      setTimeout(
        () => {
          setSubmitDelayed(false)
        },
        secondsTillFormSubmitIsAllowed(errorTime) * 1000,
      )
    }
  }, [errorTime, canRetrySubmit])

  return (
    <>
      <FormButton
        dataHook={dataHook}
        text={text}
        type="submit"
        spinner={submitDelayed || checkoutActionPending || rsvpActionPending}
        disabled={disabled || submitDelayed}
        previewTooltipText={previewTooltipText}
        onClick={onClick}
      />
      {showError ? <Error className={s.error} error={error} /> : null}
    </>
  )
}
